import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Pause, Play, SkipBack, SkipForward } from "lucide-react";
import { useAudio } from "../context/AudioContext";
import { fmt } from "../lib/api";

export default function MiniPlayer() {
  const { current, playing, time, duration, toggle, step, seek } = useAudio();
  return (
    <AnimatePresence>
      {current && (
        <motion.div
          initial={{ y: 120 }}
          animate={{ y: 0 }}
          exit={{ y: 120 }}
          transition={{ duration: 0.7, ease: [0.2, 0.75, 0.1, 1] }}
          className="fixed bottom-3 inset-x-3 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:w-[440px] z-40 bg-[#141412]/90 backdrop-blur-xl border border-[var(--line)]"
          data-testid="mini-player"
        >
          <div className="flex items-center gap-3 p-3">
            <img src={current.cover} alt="" className={`w-12 h-12 object-cover grayscale ${playing ? "rounded-full" : ""} transition-[border-radius] duration-700`} />
            <Link to="/listen" className="flex-1 min-w-0" data-testid="mini-player-title-link">
              <p className="f-display font-bold uppercase text-lg leading-none truncate">{current.title}</p>
              <p className="f-serif italic text-sm text-[var(--ash)] truncate">{current.version}</p>
            </Link>
            <button onClick={() => step(-1)} className="p-2 hover:text-[var(--signal)] transition-colors" aria-label="Previous" data-testid="mini-player-prev"><SkipBack size={16} /></button>
            <button onClick={() => toggle()} className="w-10 h-10 rounded-full border border-[var(--bone)] flex items-center justify-center hover:bg-[var(--bone)] hover:text-[var(--ink)] transition-colors duration-300" aria-label={playing ? "Pause" : "Play"} data-testid="mini-player-toggle">
              {playing ? <Pause size={16} /> : <Play size={16} className="ml-0.5" />}
            </button>
            <button onClick={() => step(1)} className="p-2 hover:text-[var(--signal)] transition-colors" aria-label="Next" data-testid="mini-player-next"><SkipForward size={16} /></button>
          </div>
          <div className="flex items-center gap-3 px-3 pb-2 f-mono text-[11px] text-[var(--ash)]">
            <span>{fmt(time)}</span>
            <input type="range" min={0} max={duration || 1} step={0.1} value={time} onChange={(e) => seek(+e.target.value)} className="range-thin" aria-label="Seek" data-testid="mini-player-seek" />
            <span>{fmt(duration)}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
